// import { createStore, applyMiddleware} from "redux";
// import thunk from "redux-thunk";
// import rootReducer from "./reducers/index.js";
// import { createLogger } from 'redux-logger';

// const loggerMiddleware = createLogger();
// const middleware = [thunk]

// if(process.env.NODE_ENV === "development"){
//     middleware.push(loggerMiddleware)
// }
// const store = createStore(rootReducer, applyMiddleware(...middleware));

// export default store;


import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers/index.js";

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancer(applyMiddleware(thunk)));

export default store;
